<template>
  <div class="labels">
    <span class="capacity text-large">Capacity</span>
    <span class="compact text-large">Compact</span>
    <span class="coverage  text-large">Coverage</span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@eds/vanilla/variables/global.less';
.labels {
  margin: @space-base @space-large;
  span {
    margin: 0 @space-small;
    padding: 0 0 2px 0;
  }
  .capacity {
    border-bottom: 2px solid @orange-50;
  }
  .compact {
    border-bottom: 2px solid @green-35;
  }
  .coverage {
    border-bottom: 2px solid @blue-43;
  }
}
</style>
